export default {"src":"/_next/static/media/shield-tick-blue.2c0e6b25.svg","height":30,"width":30};